import type { Editor, EditorEvents } from '@tiptap/core'
import { useEffect, useState } from 'react'

/**
 * Returns the element that the editor is mounted to.
 */
export const useEditorElement = (editor: Editor | null) => {
  const [editorElement, setEditorElement] = useState<Element>()

  useEffect(() => {
    if (!editor) {
      return
    }

    const onCreate = ({ editor }: EditorEvents['create']) => {
      if (editor.options.element instanceof Element) {
        setEditorElement(editor.options.element)
      }
    }

    editor.on('create', onCreate)
    return () => {
      editor.off('create', onCreate)
    }
  }, [editor])

  return editorElement
}
